// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-desktop":"(min-width: 992px)","container":"DancingHeadline-module--container--c4f735"};